import { Box } from "@mui/material";
import React from "react";
import NewProductTag from "./Components/NewProductTag";
import NewProductTagTable from "./Components/NewProductTagTable";
import { useStyles } from "../../theme/styles";

const Category: React.FC = () => {
  const classes = useStyles();

  return (
    <Box sx={{ p: 2 }} className={classes.indexBox}>
      <NewProductTag />
      <Box sx={{ height: "75px" }} />
      <NewProductTagTable />
    </Box>
  );
};

export default Category;
